import { FullscreenService } from './../../../services/fullscreen.service';
import { Component, OnDestroy, OnInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpEventType } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs/Rx';
import { Store } from '@ngrx/store';

import * as fromRoot from '../../../store/reducers';
import { TestTakerActions, AppUiActions } from '../../../store/actions';
import { MyModal } from '../../common/my-modal/my-modal.component';
import * as Enum from '../../../dtos/enums';
import { AuthService } from '../../../services/auth.service';
import { TestContentService } from '../../../services/test-content.service';
import { TestTakerService } from '../../../services/test-taker.service';
import { HttpResponse } from '@angular/common/http';
import { ConfigHelper } from 'app/services/config.helper';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'start-screen-web',
    template: require('./start-screen-web.component.html')
})
export class StartScreenWebComponent implements OnDestroy, OnInit {
    private routeParamsSubscription: Subscription;
    webDeliveryAuth: string;
    errorMsg: string;
    testTakerInfo: PgRendererDto.TestTakerStationAssignment;
    testTakerPhotoUrl: string;
    regId: number;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private testTakerService: TestTakerService,
        private store: Store<fromRoot.State>,
        private authService: AuthService,
        private myModal: MyModal,
        private fullScreenService: FullscreenService
    ) {
    }

    pollForTestTakerInfo() {
        Observable.interval(10000)
            .startWith(1)
            .flatMap(x => this.testTakerService.getStationAssignmentWebDelivery(this.webDeliveryAuth))
            .filter(x => x != null)
            .take(1)
            .retryWhen(errors => errors.delay(60000))
            .subscribe(testTakerInfo => {
                this.onStationAssignmentReceived(testTakerInfo);
            });
    }

    ngOnInit() {
        this.routeParamsSubscription = this.route.params.subscribe(params => {
            if (params) {
                this.webDeliveryAuth = params['web-delivery-auth'];
                this.pollForTestTakerInfo();
                this.authService.setWebDeliveryAuth(this.webDeliveryAuth.toString());
            }
        });
    }

    ngOnDestroy() {
        this.routeParamsSubscription.unsubscribe();
    }

    onStationAssignmentReceived(testTakerInfo: PgRendererDto.TestTakerStationAssignment) {
        this.testTakerInfo = testTakerInfo;
        this.regId = this.testTakerInfo.TestTakerId;
        this.testTakerPhotoUrl = this.testTakerService.getWebDeliveryTestTakerPhotoUrl(this.testTakerInfo.ClientApplicationSessionId as string, this.testTakerInfo.TestTakerId);
        this.store.dispatch(new TestTakerActions.SetTestTakerInfo(testTakerInfo));
        ConfigHelper.setTestTypeId(testTakerInfo.TestTypeId);
        this.authService.setAccessToken((testTakerInfo as any).Token);
    }

    clearErrorMsg() {
        this.errorMsg = "";
    }

    onStartTest() {
        this.fullScreenService.tryFullScreen().
            then(
                resolve => { this.proceedToNextStep(); },
                err => { this.myModal.showRegularDlg("Error", "Error attempting to enable full-screen mode: ${err.message} (${err.name}) \nTesting cannot proceed without fullscreen enabled"); }
            );
    }

    proceedToNextStep() {
        if (_paragonConfig.audioTestEnabled === true) {
            this.router.navigate([`start-screen/${this.testTakerInfo.TestTakerId}/audio-check`]);
        } else {
            this.testTakerService.startTest().subscribe(
                success => {
                    this.store.dispatch(new TestTakerActions.SetTestInitializationInfo(success));
                    this.testTakerService.saveTestTakerActivityWithoutCaching(Enum.TestTakerActivityTypeEnum.StartCodeCorrectInput);
                    this.router.navigate([`assessment-test/${this.testTakerInfo.AssessmentTestId}`]);
                },
                error => {
                    this.myModal.showRegularDlg("Error", error);
                }
            );
        }
    }
}


// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/start-screen/start-screen-web.component.ts